import { timestamp, timestampDiffSeconds } from "./DateTime";
import { load, save } from "./StorageIDB";

export async function idbCache<TResult>(key: string, ttlSeconds: number, createPayloadFn: () => Promise<TResult|undefined>|TResult, validatePayloadFn = (payload: any) => true): Promise<TResult|undefined> {
    const currentTimestamp = timestamp();
    
    const cachedData = await load(key);
    if(cachedData) {
        let timeDiff = timestampDiffSeconds(cachedData.timestamp, currentTimestamp);
    
        if(timeDiff <= ttlSeconds && validatePayloadFn(cachedData.payload)) {
            const cachedPayload: TResult = cachedData.payload;
            return cachedPayload;
        }
    }

    const payload = await createPayloadFn();
    save(key, {
        timestamp: currentTimestamp, 
        payload: payload,
    });

    return payload;
}